import { ServicioAdicinal } from "../impo/impo";

export class Filtro {
    booking: string;
    estado: string;
    fechainicio: string;
    fechafin: string;
    pagina: number;
}

export class sendDetalleBK {
    numeroBK: string;
    codigoLocacion: string;
    codigoNave: string;
    numeroViaje: string;
    codigoRumbo: string;
    codigoRegimen: string;
    rucEmpresa: string;
    usuario: string;
    transaccionId: string;
    codigoPickUp: string;
}

export class Booking {
    nroBooking: string;
    codTrans: string;
    nave: string;
    cantContenedor: string;
    estado: string;
    tipoTransporte: string;
    fecLiq: string;
    factura: string;
    documento: string;
    nroManifiesto: string;
    linea: string;
    fechaTransaccion: string;
    codigoPago: string;
    razonSocialClienteBk: string;
    codigoLocacion: string;
    codigoNave: string;
    numeroViaje: string;
    codigoRumbo: string;
    codigoClienteBk: string;
    codigoRegimen: string;
    transaccionId: string;
    codigoEstado: string;
    serieFactura: string;
    correlativoFactura: string;
    codigoDocFe: string;
    codigoPickUpPlan: string;


    codigoConsignatario: string;
    razonSocialConsignatario: string;

    //agregado para manejar los combos por bk
    codigoCarga: string;
    codigoModalidadRecojo: string;

    //paginacion
    paginas: string;
    cantidad: string;

    validaStock: string;
}

export class ContenedorBk {
    nroDetalleDo: string;
    fechaEntrega: string;
    tamaContenedor: string;
    tipoContenedor: string;
    estado: string;
    tipoCarga: string;
    lugarRecojo: string;
    itemSeleccionado: string;
    transaccionDetId: string;
    codigoLugarRecojo: string;

    codigoCarga: string;
    codigoEstado: string;
    codigoTipoCnt: string;
    contenedorAsig: string;
    modalidadRecojo: string;
    numeroCita: string;

    //para controlar los datos seleccionados
    check: boolean;
    //valores para seleccionar los combos
    codigoModalidadRecojo: string;
    codigoTipoCarga: string;
    codigoTipoTecnologia: any;

    //ruc transportista.
    ruc_transportista: string;
    raz_transportista: string;

    esRefrigerado: string;

    //servicioa adicionales
    ls_servicios: Array<ServicioAdicinal> = new Array<ServicioAdicinal>();
    disabled: boolean;
}

export class Modalidad {
    codigoModalidadRecojo: string;
    modalidadRecojo: string;
}

export class TipoCarga {
    tipoCarga: string;
    codigoTipoCarga: string;
}

export class Actividad {
    citaActID: string;
    descripcionAct: string;
    fechaAct: string;
}

export class PDF {
    Serie: string;
    Numero: string;
    TipoComprobante: string;
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/expo/expo.ts